import {ApiClientInterface} from "./clients";
import {PaymentSchedule} from "./models";

export class PaymentScheduleProvider {
  constructor(private readonly apiClient: ApiClientInterface) {}

  public async getPaymentSchedule(projectUuid: string):Promise<PaymentSchedule> {
    return this.apiClient.get(`/${projectUuid}`);
  }
}